import styled from 'styled-components';
import * as DesignSystem from '../../../assets/styles/StyleTypes';
import invalidIcon from '../../../assets/image/invalid.png';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: ${(props) => props.theme.colors.textPrimary};

  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }
  input[type=number] {
      -moz-appearance: textfield; 
      appearance: textfield; 
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  color: ${(props) => props.theme.colors.textPrimary};
`;

export const Label = styled.label`
  ${DesignSystem.Typography.LABEL_XXS}
  color: ${(props) => props.theme.colors.textPrimary};
  &.white-theme {
    color: ${DesignSystem.Colors.HIGH_PURE};
  }
`;

export const Small = styled.small`
  ${DesignSystem.Typography.HELPER_XXXS}
  color: ${(props) => props.theme.colors.textErrorInput};
  &.white-theme {
    color: ${DesignSystem.Colors.HIGH_PURE};
  }
`;

export const InputPassword = styled.div`
  height: 40px;
  border-radius: ${DesignSystem.BorderRadius.SM};
  padding: 0 10px;
  color: ${(props) => props.theme.colors.textPrimary};
  /* border: 1px solid ${(props) => props.theme.colors.textPrimary}; */
  background-color: ${(props) => props.theme.colors.backgroundInput};
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  box-sizing: border-box;
  outline: none;
  width: 100%;

  &.white-theme {
    color: ${DesignSystem.Colors.LOW_PURE};
    border: 1px solid ${DesignSystem.Colors.HIGH_PURE};
    background-color: ${DesignSystem.Colors.HIGH_PURE};
  }

  & > div {
    height: 40px;
    width: 40px;
    background: transparent;
  }

  & > input {
    width: 100%;
    border: none;
    background: transparent;
    height: 40px;
    line-height: 41px;
    outline: none;
    &::placeholder {
      color: #bebebe;
    }
  }
`;

export const Input = styled.input`
  ${DesignSystem.Typography.INPUT_XXS}
  height: 40px;
  border-radius: ${DesignSystem.BorderRadius.SM};
  padding: 0 10px;
  color: ${(props) => props.theme.colors.textPrimary};
  border: none;
  background-color: ${(props) => props.theme.colors.backgroundInput};
  outline: none;
  width: 100%;
  box-sizing: border-box;

  &:disabled {
    color: #A6A6A6;

  }

  &::placeholder {
    color: ${(props) => props.theme.colors.placeholderInput};
  }

  &.invalid {
    border: 1px solid ${DesignSystem.Colors.TOAST_WARNING};
    background-color: ${(props) => props.theme.colors.backgroundInputError};
    color: ${(props) => props.theme.colors.textErrorInput};
    background-image: url(${invalidIcon});
    background-repeat: no-repeat;
    background-size: 20px auto;
    background-position: 97% center;
  }

  &.white-theme {
    color: ${DesignSystem.Colors.LOW_PURE};
    border: 1px solid ${DesignSystem.Colors.HIGH_PURE};
    background-color: ${DesignSystem.Colors.HIGH_PURE};
    &::placeholder {
      color: #bebebe;
    }
  }

  &.white-theme.invalid {
    border: 1px solid ${DesignSystem.Colors.TOAST_WARNING};
    background-color: ${DesignSystem.Colors.ERROR_WARNING};
    color: ${DesignSystem.Colors.LOW_PURE};
    background-image: url(${invalidIcon});
    background-repeat: no-repeat;
    background-size: 20px auto;
    background-position: 97% center;
  }
`;

export const InputArea = styled.textarea`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  width: 508px !important;
  min-height: 100px;
  border: 1px solid #cecece;
  border-radius: 5px;
  padding: 10px;
  color: ${(props) => props.theme.colors.textPrimary};
  border: none;
  background-color: ${(props) => props.theme.colors.backgroundInput};
  outline: none;
  font-family: Roboto, sans-serif;
  font-size: 12px;
  &::placeholder {
    color: #a6a6a6;
    font-size: 12px;
  }
  width: 100%;
  box-sizing: border-box;
`;